<template>
  <div>
    <section class="content-header" style="height: 50px;">
      <a v-show="activeFilter==='Rules'" href="#" @click="$root.showNewBox" style="float: left; padding-right: 10px;"><i class="fa fa-plus-circle" style="font-size: 30px;"></i></a>
      <h1 style="float: left; padding-right: 10px;">{{ activeFilter}}</h1>
      <div action="#" method="get" class="sidebar-form" style="width: 200px; float: right; margin: 0px; border: 1px solid #337ab7;">
        <div class="input-group">
          <input type="text" name="q" class="form-control" placeholder="Search..." v-model="$root.txtSearch" style="height: 27px; background-color: #fff;">
          <div class="input-group-btn">
            <div class="btn btn-flat" style="height: 28px; padding: 4px 6px; background-color: #fff;"><i class="fa fa-search"></i></div>
          </div>
        </div>
      </div>
      <div :class="['box-tools', $root.device.isMobile?'tabsMobile':'']" style="float: right; padding: 0px 10px;">
        <ul class="pagination pagination-sm inline" style="cursor: pointer;">
          <li :class="[activeFilter==='Alerts' ? 'active' : '']"><a @click="activeFilter='Alerts'" style="width: 80px!important; text-align: center;">Alerts</a></li>
          <li :class="[activeFilter==='Rules' ? 'active' : '']"><a @click="activeFilter='Rules'" style="width: 80px!important; text-align: center;">Rules</a></li>
        </ul>
      </div>
    </section>
    <div class="box-body">
      <div class="table-responsive">
        <div class="col-sm-12" style="padding-left: 0px; background-color: #ddd; padding-bottom: 10px; border-radius: 5px;">
          <div class="col-sm-2" v-show="$root.isAdmin">
            <span>Select Dealer:</span>
            <select class="form-control" v-model="filters.dealerKey" style="padding-left: 0px;">
              <option v-for="(item,index) in $root.dealers" :value="item.value">{{ item.title }}</option>
            </select>
          </div>
          <div class="col-sm-2">
            <span>Select Customer:</span>
            <select class="form-control" v-model="filters.customerKey" style="padding-left: 0px;">
              <option value="All">All</option>
              <option v-for="(item,index) in customers" :value="item.value">{{ item.title }}</option>
            </select>
          </div>
          <div class="col-sm-2">
            <span>Select Type:</span>
            <select class="form-control" v-model="filters.alertType" style="padding-left: 0px;">
              <option value="All">All</option>
              <option v-for="(alertType,index) in $root.alertTypes" :value="alertType.value">{{ alertType.title }}</option>
            </select>
          </div>
          <div class="col-sm-2" v-show="activeFilter==='Alerts'">
            <span>From Date:</span>
            <input type="date" class="form-control" v-model="filters.fromDate" />
          </div>
          <div class="col-sm-2" v-show="activeFilter==='Alerts'">
            <span>To Date:</span>
            <input type="date" class="form-control" v-model="filters.toDate" min="filters.toDate" />
          </div>
          <div class="col-sm-2" v-show="activeFilter==='Rules'">
            <span>&nbsp;</span>
            <div class="tree-content tree--small" style="float: left!important;" @click="activeOnly=!activeOnly">
              <i :class="['tree-checkbox', activeOnly?'checked':'']"></i>
              <span tabindex="-1" class="tree-anchor">
                <span class="tree-text" style="white-space: nowrap;">Show Active Only</span>
              </span>
            </div>
          </div>
          <div class="col-sm-2" style="height: 54px;">
            <input type="button" class="btn btn-success" value="Refresh" style="margin-top: 20px;" @click="reloadAlerts" />
          </div>
        </div>
        <VueTable ref="vueTableAlerts" :guid="guidAlerts" :key="$root.getGUID()" v-show="activeFilter==='Alerts'" :isLoading="isLoading" :info="infoIcons" :columns="alertsColumns" :rows="filteredItems" @rowClick="rowClick"></VueTable>
        <!--<VueTable ref="vueTableRules" :guid="guidRules" :key="$root.getGUID()" v-show="activeFilter==='Rules'" :isLoading="isLoading" :info="infoIcons" :columns="rulesColumns" :rows="filteredItems" @rowClick="rowClick"></VueTable>-->
        <VueTable ref="vueTableRules" :guid="guidRules" v-show="activeFilter==='Rules'" :isLoading="isLoading" :info="infoIcons" :columns="rulesColumns" :rows="filteredItems" @rowClick="rowClick"></VueTable>
      </div>
    </div>
    <AddRule></AddRule>
    <va-modal></va-modal>
  </div>
</template>
<script>
  import VueTable from '../components/Table/DataTable.vue'
  import VACheckBox from '../components/VACheckBox'
  import AddRule from '../components/AddRule'
  import VASelect from '../components/VASelect'
  import Modal from '../components/Modal'
  import VAAlert from '../components/VAAlert.vue'
  import { db } from '../firebase'
  export default {
    name: 'alerts',
    components: { VueTable, 'va-alert': VAAlert, AddRule, 'va-checkbox': VACheckBox, 'va-select': VASelect, 'va-modal': Modal },
    data () {
      return {
        isLoading: false,
        guidAlerts: this.$root.getGUID(),
        guidRules: this.$root.getGUID(),
        activeFilter: 'Alerts',
        activeOnly: false,
        sortBy: 'Name',
        sortDir: 'asc',
        filters: {
          dealerKey: '',
          customerKey: '',
          alertKey: '',
          alertType: 'All',
          fromDate: '',
          toDate: ''
        },
        customers: [],
        alerts: [],
        rules: [],
        infoIcons: [
          { icon: 'fa fa-bell-o iconInformation smallIcon', label: 'System' },
          { icon: 'fa fa-exclamation-circle iconInformation rotate180 smallIcon', label: 'Information' },
          { icon: 'fa fa-exclamation-triangle iconWarning smallIcon', label: 'Warning' },
          { icon: 'fa fa-times-circle iconError smallIcon', label: 'Critical' }
        ],
        alertsColumns: [
          { fieldName: 'Type', label: '', isSortable: false, isHidden: false, isIcon: true },
          { fieldName: 'Logged', label: 'Date', isSortable: true, isHidden: false },
          { fieldName: 'CustomerName', label: 'Customer Name', isSortable: true, isHidden: false },
          // { fieldName: 'Title', label: 'Title', isSortable: true, isHidden: false, length: 50 },
          { fieldName: 'Message', label: 'Message', isSortable: true, isHidden: false, length: 500 }
        ],
        rulesColumns: [
          { fieldName: 'Type', label: '', isSortable: false, isHidden: false, isIcon: true },
          { fieldName: 'Name', label: 'Rule Name', isSortable: true, isHidden: false },
          { fieldName: 'ConditionText', label: 'Condition', isSortable: true, isHidden: false, length: 50 },
          { fieldName: 'ActionText', label: 'Action', isSortable: true, isHidden: false, length: 50 },
          { fieldName: 'CustomerName', label: 'Customer Name', isSortable: true, isHidden: false },
          { fieldName: 'IsActive', label: 'Active', isSortable: true, isHidden: false, isActive: true },
          {
            fieldName: 'VueBottons',
            isSortable: false,
            isHidden: false,
            bottons: [
              { name: 'DuplicateRule', label: 'Duplicate', iconClass: 'fa fa-clone', color: 'gray' },
              { name: 'EditRule', label: 'Edit', iconClass: 'fa fa-edit', color: 'green' },
              { name: 'DeleteRule', label: 'Delete', iconClass: 'fa fa-trash-o', color: 'red' }
            ]
          }
        ]
      }
    },
    watch: {
      activeFilter (val) {
        this.$root.txtSearch = ''
      },
      'filters.dealerKey' (val) {
        this.filters.customerKey = 'All'
        if (val === 'All') {
          this.customers = []
        } else {
          this.loadCustomers()
        }
      }
    },
    created () {
      this.$root.title = 'Alerts'
      if (this.$root.isAdmin) {
        if (this.$root.dealers && this.$root.dealers.length > 0) {
          this.filters.dealerKey = this.$root.dealers[0].value
        } else {
          this.filters.dealerKey = this.$root.user['.key']
        }
        this.filters.customerKey = 'All'
        this.filters.siteKey = 'All'
      } else {
        this.filters.dealerKey = this.$root.user['DealerUID']
      }
      this.filters.fromDate = this.$moment().add(-7, 'days').format('YYYY-MM-DD')
      this.filters.fromDate = this.$moment().add(-1, 'days').format('YYYY-MM-DD')
      this.filters.toDate = this.$moment().format('YYYY-MM-DD')
      // if (this.$root.userHistory && this.$root.userHistory.selectedTab) {
      //   this.activeFilter = this.$root.userHistory.selectedTab
      // }
      if (this.$root.userHistory) {
        if (this.$root.userHistory.selectedTab) {
          this.activeFilter = this.$root.userHistory.selectedTab
        }
        if (this.$root.userHistory.fromDate) {
          this.filters.fromDate = this.$root.userHistory.fromDate
        }
        if (this.$root.userHistory.toDate) {
          this.filters.toDate = this.$root.userHistory.toDate
        }
        this.$root.userHistory.selectedDealer = this.filters.dealerKey
        this.$root.userHistory.selectedCustomer = this.$route.params.customerKey
        this.$root.userHistory.selectedSite = this.$route.params.siteKey
        this.filters.customerKey = this.$route.params.customerKey
        this.filters.siteKey = this.$route.params.siteKey
        this.$root.setUserHistory()
      } else {
        this.filters.fromDate = this.$moment().add(-1, 'days').format('YYYY-MM-DD')
        this.filters.toDate = this.$moment().format('YYYY-MM-DD')
      }
    },
    mounted () {
      console.log('Alerts mounted...')
    },
    updated () {
      console.log('Alerts updated...')
      console.log('vueTableRules.key = ' + this.$refs.vueTableRules.key)
      console.log('vueTableRules.guid = ' + this.$refs.vueTableRules.guid)
    },
    computed: {
      hasData () {
        return this.filteredItems !== null && this.filteredItems !== undefined && this.filteredItems.length > 0
      },
      fromDateInt () {
        // return Number(this.$moment(this.filters.fromDate).format('YYYYMMDDHHmm'))
        return Number(this.$moment(this.filters.fromDate).format('YYYYMMDD') + '0000')
      },
      toDateInt () {
        // return Number(this.$moment(this.filters.toDate).format('YYYYMMDDHHmm'))
        return Number(this.$moment(this.filters.toDate).format('YYYYMMDD') + '2359')
      },
      filteredItems () {
        const vm = this
        let result = []
        if (vm.$root.txtSearch.length > 0) {
          let txtSearch = vm.$root.txtSearch.trim().toLowerCase()
          try {
            if (vm.activeFilter === 'Alerts') {
              result = vm.alerts.filter(function (row) {
                return Object.keys(row).some(function (key) {
                  if (String(row[key]).trim().toLowerCase().indexOf(txtSearch) > -1) {
                    return row
                  }
                })
              })
            }
            if (vm.activeFilter === 'Rules') {
              result = vm.rules.filter(function (row) {
                return Object.keys(row).some(function (key) {
                  if (String(row[key]).trim().toLowerCase().indexOf(txtSearch) > -1) {
                    return row
                  }
                })
              })
            }
          } catch (e) {
            console.log(e)
            result = []
          }
        } else {
          if (vm.activeFilter === 'Alerts') {
            result = vm.alerts
          }
          if (vm.activeFilter === 'Rules') {
            result = vm.rules
          }
        }
        if (vm.filters.alertType !== 'All') {
          result = result.filter(function (row) {
            return row.Type === vm.filters.alertType
          })
        }
        if (vm.activeFilter === 'Rules' && vm.activeOnly) {
          result = result.filter(function (row) {
            return row.IsActive
          })
        }
        return result
      }
    },
    methods: {
      test () {
        console.log('test...')
        alert('test')
      },
      loadCustomers () {
        console.log('loadCustomers...')
        this.customers = []
        for (let i = 0; i < this.$root.customers.length; i++) {
          if (this.$root.customers[i].dealerKey === this.filters.dealerKey) {
            this.customers.push(this.$root.customers[i])
          }
        }
      },
      reloadAlerts () {
        console.log('reloadAlerts...')
        const vm = this
        vm.isLoading = true
        vm.alerts = []
        vm.rules = []
        if (vm.activeFilter === 'Alerts') {
          this.loadAlerts()
        }
        if (vm.activeFilter === 'Rules') {
          this.loadRules()
        }
      },
      loadAlerts () {
        console.log('loadRules...')
        const vm = this
        vm.alerts = []
        vm.rules = []
        /*
         * Logged
         * LoggedInt
         * DealerKey
         * CustomerKey
         * DealerCustomerKey
         * DateDealerKey
         * DateCustomerKey
         * DateDealerCustomerKey
        */
        let childKey = ''
        let startAtValue = ''
        let endAtValue = ''
        if (vm.filters.customerKey === 'All') {
          childKey = 'DateDealerKey'
          startAtValue = vm.filters.dealerKey + '_' + vm.fromDateInt
          endAtValue = vm.filters.dealerKey + '_' + vm.toDateInt
        } else {
          childKey = 'DateDealerCustomerKey'
          startAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.fromDateInt
          endAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.toDateInt
        }
        console.log(childKey)
        console.log(startAtValue)
        console.log(endAtValue)

        db.ref('Alerts').orderByChild(childKey).startAt(startAtValue).endAt(endAtValue).limitToLast(500).on('value', (snapAlerts) => {
          const data = snapAlerts.val()
          if (data) {
            console.log(data)
            vm.alerts = []
            vm.rules = []
            const keys = Object.keys(data)
            for (let i = 0; i < keys.length; i++) {
              let key = keys[i]
              let item = data[key]
              item['.key'] = key
              let cust = vm.customers.find(c => c.value === item.CustomerKey)
              if (cust) {
                item['CustomerName'] = cust.title
              }
              vm.alerts.push(item)
            }
            vm.alerts = vm.alerts.slice().sort(function (a, b) {
              return a.LoggedInt > b.LoggedInt ? -1 : 1
            })
          } else {
            vm.alerts = []
            vm.rules = []
          }
          vm.isLoading = false
        })
      },
      loadRules () {
        console.log('loadRules...')
        const vm = this
        let orderKey = ''
        let orderValue = ''
        if (this.filters.customerKey === 'All') {
          orderKey = 'DealerKey'
          orderValue = vm.filters.dealerKey
        } else {
          orderKey = 'DealerCustomerKey'
          orderValue = vm.filters.dealerKey + '_' + vm.filters.customerKey
        }
        console.log('orderKey = ' + orderKey)
        console.log('orderValue = ' + orderValue)
        vm.alerts = []
        vm.rules = []
        db.ref('AlertRules').orderByChild(orderKey).equalTo(orderValue).once('value').then(function (snapItems) {
          const data = snapItems.val()
          if (data) {
            console.log(data)
            const keys = Object.keys(data)
            vm.alerts = []
            vm.rules = []
            for (let i = 0; i < keys.length; i++) {
              let key = keys[i]
              let item = data[key]
              item['.key'] = key
              // item['ConditionText'] = item.Condition.key + ' ' + item.Condition.operation + ' ' + item.Condition.value
              // item['ActionText'] = item.Action.key + ': ' + item.Action.value
              let cust = vm.customers.find(c => c.value === item.CustomerKey)
              if (cust) {
                item['CustomerName'] = cust.title
              }
              vm.rules.push(item)
            }
          } else {
            vm.alerts = []
            vm.rules = []
          }
          vm.isLoading = false
        })
      },
      rowClick (btn, item) {
        switch (btn) {
          case 'Activate': this.activate(item); break
          case 'DuplicateRule': this.duplicate(item); break
          case 'EditRule': this.edit(item); break
          case 'DeleteRule': this.confirmDelete(item); break
          default: break
        }
      },
      activate (item) {
        item.IsActive = !item.IsActive
        db.ref('AlertRules/' + item['.key'] + '/IsActive').set(item.IsActive)
        this.$notify({
          type: 'success',
          title: 'Rules [' + item.Name + ']',
          text: 'Rule was updated successfuly!'
        })
      },
      duplicate (item) {
        const vm = this
        // const alertRef = db.ref('AlertRules/' + item.AlertKey)
        delete item['.key']
        db.ref('AlertRules').push(item).then((snap) => {
          const newKey = snap.key
          console.log(newKey)
          console.log(snap)
          // let newItem = item // snap.val() // snap[newKey]
          let newItem = {
            DealerKey: item.DealerKey,
            CustomerKey: item.CustomerKey,
            Name: item.Name,
            Description: item.Description,
            Type: item.Type,
            Condition: item.Condition,
            Action: item.Action,
            IsActive: item.IsActive,
            ConditionText: item.ConditionText,
            ActionText: item.ActionText,
            CustomerName: item.CustomerName
          }
          console.log(newItem)
          newItem['.key'] = newKey
          vm.rules.push(newItem)
          vm.$notify({
            // type: 'warn',
            // type: 'error',
            type: 'success',
            title: 'Rules [' + newItem.Name + ']',
            text: 'Rule was duplicated successfuly!'
          })
        })
      },
      edit (item) {
        console.log('edit rule ...')
        this.$bus.$emit('rulesModal-open', item)
      },
      confirmDelete (item) {
        const vm = this
        vm.$bus.$emit('modal-open', {
          title: 'Delete Alert',
          description: 'Are you sure you want to delete [' + item.Name + ']',
          type: 'modal-primary',
          confirmText: 'Delete',
          cancelText: 'Cancel',
          confirmBefore: () => {
          },
          confirmAfter: () => {
            const alertRef = db.ref('AlertRules/' + item['.key'])
            alertRef.remove()
            vm.rules = vm.rules.filter(function (rule) {
              return rule['.key'] !== item['.key']
            })
            vm.$notify({
              type: 'warn',
              title: 'Rules [' + item.Name + ']',
              text: 'Rule was deleted!'
            })
          },
          cancelBefore: () => {
          },
          cancelAfter: () => {
          }
        })
      }
    }
  }
</script>
<style>
</style>




// WEBPACK FOOTER //
// Alerts.vue?88baae46